import React from "react";

export default function LoadingMessage() {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Ecovanta Copilot is processing the request"
      style={{
        display: "flex",
        justifyContent: "flex-start",
        marginBottom: 18
      }}
    >
      <div
        style={{
          maxWidth: "78%",
          borderRadius: 18,
          padding: "14px 16px",
          background: "#ffffff",
          color: "#55716a",
          border: "1px solid #dce8e4",
          boxShadow: "0 8px 24px rgba(24, 52, 46, 0.07)"
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10
          }}
        >
          <span
            aria-hidden="true"
            style={{
              display: "inline-flex",
              gap: 4
            }}
          >
            {[0, 1, 2].map((index) => (
              <span
                key={index}
                style={{
                  width: 7,
                  height: 7,
                  borderRadius: "50%",
                  background: "#2c6b5b",
                  opacity: 0.5,
                  animation: `copilotPulse 1.2s ${
                    index * 0.18
                  }s infinite ease-in-out`
                }}
              />
            ))}
          </span>

          <span>Ecovanta Copilot is analysing your workspace...</span>
        </div>
      </div>
    </div>
  );
}